import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './CoveragesTermsIterableComponent.metadata.json5';
import styles from '../../Policies/Summary/Summary.module.scss';

function CoveragesTermsIterableComponent(props) {
    const { data: termsData } = props;

    const resolvers = {
        resolveClassNameMap: styles
    };

    const generateCoverageTermsOverrides = useCallback(() => {
            const overrides = termsData.terms.map((term, tindex) => ({
                    [`coverageRecordValue${tindex}`]: {
                        visible: !term.isTitle_Ext
                    }
                }));
    
            return Object.assign({}, ...overrides);
        }, [termsData]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left'
        },
        ...generateCoverageTermsOverrides()
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={termsData}
            classNameMap={resolvers.resolveClassNameMap}
            overrideProps={overrideProps}
        />
    );
}

CoveragesTermsIterableComponent.propTypes = {
    data: PropTypes.shape({}).isRequired
};

export default CoveragesTermsIterableComponent;
